import { bottombarLinks } from "@/constants";
import { Link, useLocation } from "react-router-dom";

const Bottombar = ({ scrollDir }: { scrollDir: "up" | "down" }) => {
  const { pathname } = useLocation();

  return (
    <section
      className={`bottom-bar fixed bottom-0 left-0 right-0 z-50 bg-dark-2 flex justify-around py-2 transition-transform duration-300 ${
        scrollDir === "down" ? "translate-y-full" : "translate-y-0"
      }`}
    >
      {bottombarLinks.map((link) => {
        const isActive = pathname === link.route;

        const commonClasses = `flex flex-col items-center justify-center gap-1 rounded-[10px] px-3 py-2 transition`;
        const imageClasses = `w-[24px] h-[24px] ${isActive ? "invert-white" : ""}`;
        const textClasses = `tiny-medium text-light-2`;
        if (link.label === "Live") {
          return (
            <Link
              key={`bottombar-${link.label}`}
              to={link.route}
              className={`${commonClasses} ${
                isActive ? "bg-red" : ""
              }`}
            >
              <img src={link.imgURL} alt={link.label} className={imageClasses} />
              <p className={textClasses}>{link.label}</p>
            </Link>
          );
        }

        return (
          <Link
            key={`bottombar-${link.label}`}
            to={link.route}
            className={`${commonClasses} ${
              isActive ? "bg-primary-500" : ""
            }`}
          >
            <img src={link.imgURL} alt={link.label} className={imageClasses} />
            <p className={textClasses}>{link.label}</p>
          </Link>
        );
      })}
    </section>
  );
};

export default Bottombar;
